import { gql } from "@apollo/client";

const GET_NAVBAR_INFO = gql`
  query GetNavbarInfo {
    me {
      givenName
      familyName
      image
      unreadNotificationsCount
    }
    myCredits {
      totalAmount
    }
  }
`;

export default GET_NAVBAR_INFO;
